import { withResponseHandling, prepareApiRequest } from './utils'

const createApiClient = ({ apiUrl, apiToken }) => {
  return {
    createOrder: async (businessArea, values) => {
      const { url, headers } = prepareApiRequest({
        apiUrl,
        apiToken,
        endpoint: `/api/v1/orders/${businessArea}/catalog_order`
      })
      const res = await fetch(url, {
        headers,
        method: 'POST',
        body: JSON.stringify(values),
      })
      return withResponseHandling(res)
    },
    fetchOrganisationCaps: async (businessArea) => {
      const { url, headers } = prepareApiRequest({
        apiUrl,
        apiToken,
        endpoint: `/api/v1/caps/${businessArea}`,
      })
      const res = await fetch(url , {
        headers,
        method: 'GET',
      })

      return withResponseHandling(res)
    }
  }
}

export {
  createApiClient
}
